import { useApi, fetchInitialOptions } from '@data-access';
import { DataCollectionOptions } from '@types';
import { useEffect, useState } from 'react';

export const useDataCollectionOptions = () => {
  const { api, questionnaireApi } = useApi();
  const [options, setOptions] = useState<DataCollectionOptions | undefined>();

  useEffect(() => {
    fetchInitialOptions(api, questionnaireApi).then(initialOptions => {
      if (!initialOptions) return;
      setOptions(initialOptions);
    });
  }, [api, questionnaireApi]);

  return { options };
};
